import PropTypes from "prop-types"
import React from "react"
import InvoiceLink from "src/main/Billing/Links/InvoiceLink"

import { INVOICE_ICON } from "./helpers"

const CHIP_CLASSES =
  "flex items-center gap-2 rounded-full border border-gray-300 bg-gray-100 px-2 py-1 text-sm font-semibold"

// An invoice links to its page only where that page is open to the marina.
const PaymentAppliedTo = ({ invoices }) => {
  const label = `Applied to (${invoices.length})`

  return (
    <section
      aria-label={label}
      className="flex flex-col gap-2 border-b border-gray-200 pb-6"
    >
      <div className="text-sm text-gray-700">{label}</div>
      <ul className="m-0 flex list-none flex-wrap gap-2 p-0">
        {invoices.map((invoice) => (
          <li key={invoice.invoiceId}>
            {invoice.invoicePath ? (
              <InvoiceLink
                invoiceId={invoice.invoiceId}
                href={invoice.invoicePath}
                className={`${CHIP_CLASSES} text-blue-600 no-underline hover:border-blue-600 hover:bg-blue-50`}
              >
                <i className={INVOICE_ICON} aria-hidden="true" />
                {invoice.displaySequentialId}
              </InvoiceLink>
            ) : (
              <span className={`${CHIP_CLASSES} text-gray-900`}>
                <i className={INVOICE_ICON} aria-hidden="true" />
                {invoice.displaySequentialId}
              </span>
            )}
          </li>
        ))}
      </ul>
    </section>
  )
}

PaymentAppliedTo.propTypes = {
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      invoiceId: PropTypes.string.isRequired,
      displaySequentialId: PropTypes.string.isRequired,
      invoicePath: PropTypes.string,
    })
  ).isRequired,
}

export default PaymentAppliedTo
